'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (nextState, reducerName, action) {
    if (typeof nextState === 'undefined') {
        throw new Error('Reducer "' + reducerName + '" returned undefined when handling "' + action.type + '" action. To ignore an action, you must explicitly return the previous state.');
    }

    return null;
};

module.exports = exports['default'];
//# sourceMappingURL=validateNextState.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-immutable/dist/utilities/validateNextState.js
 ** module id = 1627
 ** module chunks = 0
 **/